module.exports = __webpack_public_path__ + "static/img/icon-water.4567624e.png";